import { Injectable } from '@angular/core';

import { AutoEmailRule } from '../../models/auto-email-rule';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AutoEmailRuleService extends BackendBaseService {
  url: string = 'auto_email_rules';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  save(autoEmailRule: AutoEmailRule): Promise<any> {
    return super.save({
      auto_email_rule: autoEmailRule,
      id: autoEmailRule.id
    });
  }
}
